"use client";

import Link from "next/link";
import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { InfoCallout } from "./parts";

export default function VpnComparison() {
  const reduced = useReducedMotion() ?? false;

  return (
    <section
      aria-labelledby="proxy-vs-vpn-heading"
      className="border-border py-section-sm relative border-b"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={reduced ? false : { opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={scrollRevealViewport}
          transition={{ duration: 0.5 }}
        >
          <p className="text-muted-foreground mb-3 text-xs font-semibold">Proxy vs. VPN</p>
          <h2
            id="proxy-vs-vpn-heading"
            className="text-foreground mb-6 scroll-mt-40 text-3xl font-bold tracking-tight sm:text-4xl"
          >
            Proxy versus VPN
          </h2>
          <InfoCallout>
            <p className="text-muted-foreground text-base leading-relaxed">
              A proxy normally applies to a configured application or protocol. A VPN generally
              creates an operating-system-level tunnel that can cover traffic from multiple
              applications. Performance and privacy depend on the specific implementation rather
              than one category being universally faster or safer.
            </p>
          </InfoCallout>
          <p className="text-muted-foreground text-sm leading-relaxed">
            For the longer breakdown, see the full{" "}
            <Link
              href="/proxy-server/vpn-vs-proxy"
              className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
            >
              VPN vs. proxy comparison
            </Link>
            .
          </p>
        </motion.div>
      </div>
    </section>
  );
}
